module.exports = __webpack_public_path__ + "static/media/Canal-Convergence-Logo_1.b0ef2368.jpg";